import _ from 'lodash'
import Generic from './generic'
import School from './school'
import Participation from './participation'

export class User extends Generic {
  get isSuperuser() { return this.role === 'Superuser' }
  get isStudent()   { return this.role === 'Student'   }
  get isTeacher()   { return this.role === 'Teacher'   }
  get isParent()    { return this.role === 'Parent'    }

  get asStudent() {
    return this instanceof Student ? this : new Student(this._attributes)
  }

  get asTeacher() {
    return this instanceof Teacher ? this : new Teacher(this._attributes)
  }

  get asParent() {
    return this instanceof Parent ? this : new Parent(this._attributes)
  }

  get fullName() { return '' }
  get isFromEvent() { return !!this.from_event }

  get transform() {
    if (this.isStudent)      return this.asStudent
    else if (this.isTeacher) return this.asTeacher
    else if (this.isParent)  return this.asParent
    else                     return this
  }
}

export class Superuser extends User {}

export class Student extends User {
  constructor({ participation, ...attributes }) {
    super(attributes)

    this._participation = participation ? new Participation(participation) : null
  }

  get fullName() {
    switch(window.COUNTRY) {
    case 'IN':
    case 'BR':
      return _.compact([this.name, this.surname]).join(' ')
    default:
      return _.compact([this.surname, this.name]).join(' ')
    }
  }

  get participation() { return this._participation }
  get isParticipated() {
    return this.participation && this.participation.isAwardee
  }

  get isMale() { return this.gender == 1 }
  get isFemale() { return !this.isMale }
  get isPretending() { return this.pretending == true }
  get isSelfEducated() { return !!this._attributes.self_educated }
}

export class Teacher extends User {
  constructor({ school, ...attributes }) {
    super(attributes)

    this._school = school ? new School(school) : null
  }

  get lastName() { return this._attributes.last_name }
  get firstName() { return this._attributes.first_name }
  get middleName() { return this._attributes.middle_name }
  get school() { return this._school }

  get fullName() {
    switch(window.COUNTRY) {
    case 'RU':
      return _.compact([this.lastName, this.firstName, this.middleName]).join(' ')
    case 'CN':
      return _.compact([this.lastName, this.firstName]).join(' ')
    default:
      return _.compact([this.firstName, this.lastName]).join(' ')
    }
  }
}

export class Parent extends User {
  get lastName() { return this._attributes.last_name }
  get firstName() { return this._attributes.first_name }
  get middleName() { return this._attributes.middle_name }

  get fullName() {
    switch(window.COUNTRY) {
    case 'RU':
      return _.compact([this.lastName, this.firstName, this.middleName]).join(' ')
    case 'CN':
      return _.compact([this.lastName, this.firstName]).join(' ')
    default:
      return _.compact([this.firstName, this.lastName]).join(' ')
    }
  }
}
